module.exports = __webpack_public_path__ + "static/img/A-360-1.aaf508b3.png";